const requests = {
  getPointCloudGeosearchRequest: ({ contentId }) => ({
    url: `api/pointCloudGpsMetadata/contents/${contentId}`,
    method: 'GET',
  }),
}

export default requests
